<div class="container-fluid margin-top-custom">
  <div class="title">
    <a [routerLink]="['/settings/banner-positions']"
      >{{ 'label.ManageBanners' | translate }}
    </a>
    <div>></div>
    <div>{{ bannersModel?.bannerPositionName }}</div>
  </div>

  <p-tabView [activeIndex]="tabIndex">
    <p-tabPanel header="{{ 'label.Desktop' | translate }}">
      <app-ads-tab-list
        [bannerList]="bannersModel?.desktopBannerList"
        [isResponsive]="false"
        [bannerSizes]="bannersModel?.desktopBannerSizes"
      ></app-ads-tab-list>
    </p-tabPanel>
    <p-tabPanel header="{{ 'label.Responsive' | translate }}">
      <app-ads-tab-list
        [bannerList]="bannersModel?.resposiveBannerList"
        [isResponsive]="true"
        [bannerSizes]="bannersModel?.responsiveBannerSizes"
      ></app-ads-tab-list>
    </p-tabPanel>
  </p-tabView>
</div>
